import React from 'react';
import { useDispatch } from 'react-redux';
import { setMobileMenuOpen } from '../../Actions/Navigation.action';
import Icon from '../IconBase/Icon';

const NavigationMobileTrigger = () => {
  const dispatch = useDispatch();

  return (
    <div cursor="pointer">
      <Icon iconCode="menu" onClick={() => dispatch(setMobileMenuOpen(true))} />
    </div>
  );
};

export default NavigationMobileTrigger;
